.app {
  position: relative;
  height: 100dvh;
  width: 100%;
  max-width: var(--app-max);
  margin: 0 auto;
  overflow: hidden;
  background: var(--bg);
  --bottom-chrome: calc(var(--nav-h) + var(--safe-b));
}

.app[data-chrome='focus'] {
  --bottom-chrome: var(--safe-b);
}

.app[data-mini='on'] {
  --bottom-chrome: calc(var(--nav-h) + var(--mini-h) + var(--safe-b));
}

/* Feed: reserves the nav bar, plus the mini-player when music is playing. */
.app[data-chrome='immersive'] {
  --feed-bottom: calc(var(--nav-h) + var(--safe-b));
}

.app[data-chrome='immersive'][data-mini='on'] {
  --feed-bottom: calc(var(--nav-h) + var(--mini-h) + var(--safe-b));
}

@media (min-width: 560px) {
  .app {
    border-left: 1px solid var(--border);
    border-right: 1px solid var(--border);
  }
}

.viewport {
  position: absolute;
  inset: 0;
}

.pageSlot {
  position: absolute;
  inset: 0;
}

.pageSlot[hidden] {
  display: none;
}

.centered {
  display: grid;
  place-items: center;
  height: 60dvh;
  color: var(--text-3);
}

.skip {
  position: absolute;
  left: -999px;
  top: 8px;
  z-index: 1000;
  background: var(--accent);
  color: var(--accent-ink);
  padding: 8px 12px;
  border-radius: var(--r-sm);
  font-weight: 700;
}

.skip:focus {
  left: 8px;
}
